module.exports = __webpack_public_path__ + "img/icon_ing.74280190.png";